import moment from 'moment';
import React from 'react';
import { Modal, ModalHeader, Form, Input, Col, Row, Label, FormGroup, ModalFooter, ModalBody, FormFeedback, Table } from 'reactstrap';
import 'animate.css';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';




export const ModalQuoter = (props) => {

    const {

        modal, toggle, loading, handleGetQuoter, code_quoter, date_quoter,
        handleInputChangeQuoter, validationsQuoter, listQuoter, searchQuoterByCode,
        enableViewTest, viewTestQuoter, handleViewTest, handleCloseViewTest,

    } = props;

    const {
        code_quoter_valid,
        date_quoter_valid
    } = validationsQuoter;



    const headerStyle = {
        backgroundColor: "#0f172a",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    return (
        <Dialog
            visible={modal}
            onHide={toggle}
            footer={null}
            maskClassName="custom-total-mask"
            header={
                <div className="Global-dialog-header">
                    <div className="Global-dialog-header__content">

                        <div className="Global-dialog-icon">
                            <i className="fa fa-file-text-o f-20"></i>
                        </div>

                        <div>
                            <div className="Global-dialog-title">
                                Cargar cotización
                            </div>
                        </div>

                    </div>
                </div>
            }

            className={`Global-dialog Global-dialog Global-blue Global-medium `}

        >
            <Row className='m-t-10'>
                <Col sm="12" md="12" lg="12" xl="12">
                    <Form onSubmit={handleGetQuoter}>
                        <Row className="g-3 align-items-center justify-content-start text-left pt-2 pb-2">
                            <Col xs="12" md="3" className="mb-2">
                                <h5 style={{ color: "#fb7400" }} className="f-12 f-w-700  mb-0">Ingresa el código o nombre</h5>
                            </Col>
                            <Col xs="12" md="3" className="d-flex flex-column align-items-start mb-2 pl-0">
                                <Input disabled={loading ? true : false} name="code_quoter" invalid={code_quoter_valid} className="form-control form-control-sm input-air-primary b-r-9 text-left" autoComplete='off' value={code_quoter} onChange={handleInputChangeQuoter} />
                            </Col>
                            <Col xs="12" md="1" className="mb-2">
                                <h5 style={{ color: "#fb7400" }} className="f-12 f-w-700  mb-0">Fecha</h5>
                            </Col>
                            <Col xs="12" md="3" className="d-flex flex-column align-items-start mb-2 pl-0">
                                <Input disabled={loading ? true : false} type='date' name='date_quoter' invalid={date_quoter_valid} value={date_quoter} onChange={handleInputChangeQuoter} min={moment().format("DD/MM/YYYY")} className='form-control form-control-sm  input-air-primary' />
                            </Col>
                            <Col
                                xs="12"
                                md="2"
                                className="d-flex align-items-end mb-2 pl-0"
                            >
                                <Button
                                    type="submit"
                                    label={loading ?
                                        <>
                                            <i className="pi pi-spin pi-spinner" style={{ fontSize: "1rem", marginRight: '0.5rem' }} />
                                            Buscando...
                                        </>
                                        :
                                        "Buscar"}
                                    severity="warning"
                                    rounded
                                    style={{
                                        fontSize: '12px',
                                        padding: '0.5em 1em',
                                        borderRadius: '30px',
                                        width: 'auto',
                                        display: 'block',
                                        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                                        transition: 'all 0.3s ease-in-out',
                                        border: 'none',
                                    }}
                                    disabled={loading}
                                />

                            </Col>
                        </Row>
                        <Row className={`${!enableViewTest ? 'm-t-10 ' : ''}`} hidden={enableViewTest}>
                            <Col sm="12" md="12" lg="12" xl="12">
                                <div className='table-responsive'>
                                    <DataTable
                                        value={listQuoter}
                                        paginator
                                        rows={10}
                                        className="data-table p-datatable-striped p-datatable-sm"
                                        emptyMessage={
                                            <div className="text-center">
                                                <img src={require("../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "40%" }} alt="Sin Cotizaciones" />
                                                <br />
                                                <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>Sin cotizaciones.</p>
                                            </div>
                                        }
                                        loading={loading}
                                        rowsPerPageOptions={[10, 50, 100]}
                                        responsiveLayout="scroll"
                                    >
                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
                                        <Column field="code" header="Código" headerStyle={headerStyle} style={cellStyle} />
                                        <Column
                                            field="date"
                                            header="Fecha"
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />
                                        <Column
                                            header="Pruebas"
                                            body={(rowData) => (
                                                <Tag
                                                    className='pointer'
                                                    severity="warning"
                                                    onClick={() => handleViewTest(rowData.id_quoter)}
                                                    value={<i className="fa fa-flask"></i>} >

                                                </Tag>


                                            )}
                                            headerStyle={headerStyle}
                                            style={cellStyle}
                                        />
                                        <Column
                                            header="Acciones"
                                            headerStyle={headerStyle}
                                            style={{ ...cellStyle, textAlign: "center" }}
                                            body={(rowData) => (
                                                <div className="d-flex justify-content-center gap-2">
                                                    <Button
                                                        type="button"
                                                        size="sm"
                                                        outline
                                                        style={{
                                                            fontSize: '0.75rem',
                                                            padding: '0.25em 0.5em',
                                                            borderRadius: '20px',
                                                            height: '30px',
                                                            width: 'auto',
                                                            letterSpacing: '0.5px',
                                                            boxShadow: 'none',
                                                            backgroundColor: '#28a745',
                                                            borderColor: '#28a745',
                                                            color: '#fff',
                                                        }}
                                                        onClick={() => searchQuoterByCode(rowData.code)}
                                                    >
                                                        Activar
                                                    </Button>


                                                </div>
                                            )}
                                        />
                                    </DataTable>
                                </div>
                            </Col>
                        </Row>
                        <Row className={`${enableViewTest ? ' m-t-10' : 'd-none'} `}>
                            <Col sm="12" md="12" lg="12" xl="12" className='m-b-10' style={{ "textAlign": "-webkit-right" }}>

                            </Col>
                            <Col sm="12" md="12" lg="12" xl="12">
                                <Col sm="12" className="p-l-0 p-r-0 pt-4">
                                    {viewTestQuoter.id_quoter !== undefined && (
                                        <table className="table-xs table-orange" style={{ width: "100%", borderCollapse: "collapse", border: "1px solid #ddd" }}>
                                            <thead>
                                                <tr >
                                                    <th
                                                        style={{
                                                            textAlign: "left",
                                                            padding: "8px",
                                                            border: "1px solid #ddd",
                                                            display: 'flex',
                                                            justifyContent: 'space-between',
                                                            alignItems: 'center'
                                                        }}
                                                        colSpan={2}
                                                    >
                                                        <h5 style={{ margin: 0 }}>Listado de exámenes / perfiles</h5>

                                                        <Button
                                                            type="button"
                                                            color="danger"
                                                            size="xs"
                                                            className="mt-1"
                                                            style={{
                                                                fontSize: '0.75rem',
                                                                padding: '0.25em 0.5em',
                                                                borderRadius: '20px',
                                                                height: '30px',
                                                                width: 'auto',
                                                                letterSpacing: '0.5px',
                                                                boxShadow: 'none',
                                                                backgroundColor: '#b71414ff',
                                                                borderColor: '#b71414ff',
                                                                color: '#fff',
                                                            }}
                                                            onClick={() => handleCloseViewTest()}
                                                        >
                                                            <i className="fa fa-times"></i> &nbsp;Cerrar
                                                        </Button>
                                                    </th>
                                                </tr>
                                                <tr style={{ backgroundColor: "#f4f4f4" }}>
                                                    <th style={{ textAlign: "left", padding: "8px", border: "1px solid #ddd" }}>Código</th>
                                                    <th style={{ textAlign: "left", padding: "8px", border: "1px solid #ddd" }}>Nombre</th>

                                                </tr>
                                            </thead>
                                            <tbody>
                                                {viewTestQuoter.listProfilePrices.map(obj => (
                                                    <tr key={`tr-profile-${obj.id_profile}`}>
                                                        <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                            {obj.code}
                                                        </td>
                                                        <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                            {obj.name}
                                                        </td>
                                                    </tr>
                                                ))}
                                                {viewTestQuoter.listExamPrices.map(obj => (
                                                    <tr key={`tr-exam-${obj.id_exam}`}>
                                                        <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                            {obj.code}
                                                        </td>
                                                        <td style={{ padding: "8px", border: "1px solid #ddd" }}>
                                                            {obj.name}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    )}
                                </Col>

                            </Col>
                        </Row>
                        <br />
                    </Form >
                </Col>
            </Row>
        </Dialog>
    )
}
